<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import modalPedido from './modal-pedido.vue'
	import Iconify from '../daniel/iconify.vue'

	export default {
		name: 'misPedidos',

		// COMPONENTS
		components: { modalPedido, Iconify },
		
		// DATA
		data: () => {
			return {
				isLoading: false
			}
		},

		// COMPUTED
		computed: {
			...mapGetters(['pedidosGetIndex'])
		},

		// METHODS
		methods: {
			...mapActions(['pedidosUpdate']),
			displayPedidoModal(pedidoId, numeroOrden){
				this.$refs.modalPedido.openPedidoById(pedidoId, `Pedido #${numeroOrden}`)
			}
		},

		// MOUNTED
		async mounted() {
			this.isLoading = true;
			await this.pedidosUpdate()
			this.isLoading = false;
		}
}
</script>

<template>
	<div id="misPedidos">

		<!-- MODAL DE PEDIDO -->
		<modal-pedido ref="modalPedido" />


		<!-- CARGANDO / VIEW -->
		<div class="isLoading" v-if="isLoading">
			<h6>Cargando...</h6>
			<hr class="c-hr">
		</div>

		<!-- INDICE DE RESULTADOS -->
		<div class="content" v-else-if="pedidosGetIndex.length">

			<!-- TALBE LIKE HEADER -->
			<b-row class="mt-2 mb-2" align-v="center">
				<b-col>Orden</b-col>
				<b-col>Estatus</b-col>
				<b-col>Total</b-col>
				<b-col cols="4">Guía de rastreo</b-col>
				<b-col class="b-to-end">
					&nbsp;
				</b-col>
			</b-row>

			<!-- SEPARATOR -->
			<hr class="c-hr">

			<!-- ITEMS IN TABLE -->
			<b-row v-for="item in pedidosGetIndex" :key="item.id" class="mb-2" align-v="center">
				<b-col>#{{item.numero_orden}}</b-col>
				<b-col>{{item.pedido_estatus}}</b-col>
				<b-col>{{item.total | currency}}</b-col>
				<b-col cols="4">{{item.guia_rastreo}}</b-col>
				<b-col class="b-to-end">
					<b-button variant="primary" size="sm" @click="displayPedidoModal(item.id, item.numero_orden)"><i class="fa fa-file"></i></b-button>
				</b-col>
			</b-row>

		</div>

		<div class="content" v-else>
			<iconify>
				Actualmente no tienes pedidos pendientes.
			</iconify>
		</div>

	</div>
</template>

<style lang="less">
	#misPedidos {
		.b-to-end {
			display: flex;
			justify-content: flex-end;
			button {
				transform: scale(0.75);
			}
		}
	}
</style>